import { useSettingsSupplier } from "@/app/Suppliers/Utils/useSettingsSupplier";
import { SettingCard } from "@/app/Settings/Settings/Components/SettingFormCard";
import { useTranslations } from "use-intl";
import { VehicleGrid } from "@/app/Vehicles/Components/VehicleGrid";
import { SupplierPurchasableExtraGrid } from "@/app/Suppliers/Components/SupplierPurchasableExtraGrid";
import { NoSupplierEmptyState } from "@/app/Settings/Settings/Components/NoSupplierEmptyState";

export function SettingsVehicleScreen() {
  const { supplier } = useSettingsSupplier();
  const t = useTranslations("settings.vehicles");
  const tExtras = useTranslations("settings.extras");

  if (!supplier) {
    return <NoSupplierEmptyState />;
  }

  return (
    <div className="space-y-8">
      <SettingCard title={t("title")} description={t("description")}>
        <VehicleGrid supplierId={supplier.id} addLabel={t("addButton")} />
      </SettingCard>

      <SettingCard
        title={tExtras("purchasableExtras.title")}
        description={tExtras("purchasableExtras.description")}
      >
        <SupplierPurchasableExtraGrid supplier={supplier} />
      </SettingCard>
    </div>
  );
}
